import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class RecruitmentAuthority extends HrCommonAuthority {

    public static readonly RECRUITMENT_BASE = "recruitment";

    constructor(authority: string) {
        super(combineAuth(RecruitmentAuthority.RECRUITMENT_BASE, authority));
    }

}
